import React from "react";
import { Link } from "react-router-dom";
import "./CountryDetails.css";
import CountryInfo from "../../components/content/country-info/CountryInfo";

const CountryDetails = () => {

  return (
    <div id="country__details" className="container mt-4">
      <div className="row mb-5">
        <div className="col">
          <Link to="/" className="btn btn-light px-4">
            <i className="fa fa-long-arrow-left me-2" aria-hidden="true"></i>
            <span>Back</span>
          </Link>
        </div>
      </div>
      <CountryInfo />
    </div>
  );
};

export default CountryDetails;
